<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';

const route = useRoute();
const contentWidthClass = computed(() =>
  route.name === 'account_download_reports' ? 'max-w-[90rem]' : 'max-w-5xl'
);
</script>

<template>
  <div class="overflow-auto bg-n-surface-1 w-full px-6">
    <div class="mx-auto pb-12" :class="contentWidthClass">
      <router-view />
    </div>
  </div>
</template>
